<template>
    <button
        v-tippy="{ placement: 'left' }"
        content="Chat with us"
        type="button"
        aria-label="Open chat"
        id="support-chat-launcher"
        @click="openChat"
        class="support-chat-launcher fixed bottom-8 right-8 z-[110] flex h-12 w-12 items-center justify-center rounded-full bg-blue-800 p-0 text-white active:top-auto"
    >
        <svg
            class="support-chat-launcher-icon h-6 w-6"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M10,18 L6,22 L6,18 L10,18 Z M17,6 C19.7614237,6 22,8.23857625 22,11 C22,13.7614237 19.7614237,16 17,16 L17,16 L7,16 C4.23857625,16 2,13.7614237 2,11 C2,8.23857625 4.23857625,6 7,6 L7,6 Z"
                fill="currentColor"
                transform="translate(12, 14) scale(-1, 1) translate(-12, -14)"
            />
        </svg>
        <span
            v-if="unreadCount > 0"
            id="support-chat-unread-count"
            class="support-chat-unread-count absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-600 px-1 text-xs text-white"
        >
            {{ unreadCount }}
        </span>
    </button>
</template>

<script lang="ts">
import { analytics } from "@/services/segment.ts";

function waitForZendesk(
    time: number,
    isCancelled: () => boolean,
    retriesLeft = 5
): Promise<((...args: unknown[]) => void) | null> {
    if (isCancelled()) {
        return Promise.resolve(null);
    }

    const zendesk = (window as any).zE;
    if (typeof zendesk === "function") {
        return Promise.resolve(zendesk);
    }
    if (retriesLeft <= 0) {
        return Promise.resolve(null);
    }

    return new Promise((resolve) => {
        window.setTimeout(() => {
            waitForZendesk(time, isCancelled, retriesLeft - 1).then(resolve);
        }, time);
    });
}

export default {
    data() {
        return {
            unreadCount: 0,
            isUnmounted: false,
        };
    },
    async mounted() {
        const zendesk = await waitForZendesk(1000, () => this.isUnmounted);
        if (!zendesk || this.isUnmounted) {
            return;
        }

        zendesk("messenger:on", "unreadMessages", (count: number) => {
            if (!this.isUnmounted) {
                this.unreadCount = count;
            }
        });
    },
    beforeUnmount() {
        this.isUnmounted = true;
    },
    methods: {
        openChat() {
            const zendesk = (window as any).zE;
            if (typeof zendesk === "function") {
                zendesk("messenger", "open");
                analytics.track("Chat Launcher Bottom Right Clicked");
            }
        },
    },
};
</script>
